import React from 'react';
import clsx from 'clsx';
import styles from './RangeInput.module.scss';

const RangeInput = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  variant = 'default',
  className,
  ...rest
}) => {
  return (
    <input
      type="range"
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      className={clsx(
        styles.root,
        styles[variant],
        disabled && styles.disabled,
        className
      )}
      {...rest}
    />
  );
};

export default RangeInput;
